import { readSocialPostPreviewCard, type SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { awaitsDecision, type BucketableTask } from './agent-task-buckets';

export { postPreviewHoldsDecision } from './task-row-post-preview';

type CardSource = Parameters<typeof readSocialPostPreviewCard>[0];

export function taskPostPreviewCard(task: BucketableTask & { display?: unknown }): SocialPostPreviewCardMetadata | null {
  const card = readSocialPostPreviewCard(task.display as CardSource);
  if (!card) return null;
  if (task.status === 'ACTION_NEEDED') return card;
  return awaitsDecision(task) && task.decisionPrompts?.some((prompt) => prompt.decisionId === card.decisionId) ? card : null;
}
